<template>
  <div class="flex-column-center">
    <el-container class="nesc_jianjie">
      <div class="banner_h">
        <video-player
          ref="videoPlayer"
          class="vjs-custom-skin"
          :playsinline="true"
          :options="playerOptions"
          @ended="onPlayerEnded($event)"
        />
      </div>

      <el-header>
        <h3 class="nesc_title40">{{ $t('lang.companyProfile') }}</h3>
      </el-header>
      <!-- 企业简介 -->
      <el-main>
        <div class="nesc_cont1360 nesc_about_content clearfix">
          <div class="nesc_d2s1_txt">
            <p>{{ $t('lang.companyProfileContent') }}</p>
          </div>
        </div>
      </el-main>
    </el-container>
    <el-container class="nesc_history">
      <div class="nesc_cont1360 nesc_about_content">
        <header class="about-title padding-top">
          <h3>{{ $t('lang.developmentHistory') }}</h3>
          <p>HISTORY</p>
        </header>

        <div class="about-history-list pc">
          <swiper class="swiper flex-viewport slides history-swiper " :options="swiperOption">
            <swiper-slide v-for="item in developmentHistory" :key="item.time">
              <div class="item flex-column-center">
                <h3>{{ item.time }}</h3>
                <div class="desc"><p> {{ $t('lang.' + item.content) }}</p></div>
              </div>
            </swiper-slide>
            <div slot="button-prev" class="swiper-button-prev" />
            <div slot="button-next" class="swiper-button-next" />
          </swiper>
        </div>

        <div class="about-history-list phone">
          <el-timeline>
            <el-timeline-item v-for="item in developmentHistory" :key="item.time" :timestamp="item.time" placement="top">
              <el-card>
                <h4>{{ $t('lang.' + item.content) }}</h4>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </div>

        <!--
        <el-row type="flex" class="row-bg" justify="center">
          <el-col class="flex-row-center" :xs="20" :lg="18" :md="16" :sm="14" :xl="12" >
            <img :src="hisImg" style="width: 100%;max-width: 824px;">
          </el-col>
        </el-row>
        -->
      </div>

    </el-container>
  </div>
</template>

<script>
import hisImg from '../../assets/image/history.png'
import { videoPlayer } from 'vue-video-player'
import 'video.js/dist/video-js.css'

export default {
  name: 'CompanyProfile',
  components: {
    videoPlayer
  },
  data: () => {
    return {
      loop: false,
      loadDH: false,
      hisImg: hisImg,
      developmentHistory: [],
      swiperOption: {
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 30,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      videoUrl: '',
      playerOptions: {}
    }
  },
  computed: {

  },
  created() {
  },
  mounted() {
    this.developmentHistory = [
      { time: '2015', content: 'historyList2015' }, { time: '2016', content: 'historyList2016' }, {
        time: '2017',
        content: 'historyList2017'
      },
      { time: '2018', content: 'historyList2018' }, { time: '2021', content: 'historyList2021' }, {
        time: '2022~2025+',
        content: 'historyList2022'
      }]
    this.videoUrl = this.domainUrl + '/upload/video/nesc.mp4'
    this.playerOptions = {
      autoplay: true, // 如果为true,浏览器准备好时开始回放。
      muted: false, // 默认情况下将会消除任何音频。
      loop: false, // 是否视频一结束就重新开始。
      preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
      language: 'zh-CN',
      aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
      fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
      sources: [{
        type: 'video/mp4', // 类型
        src: this.videoUrl
      }],
      poster: '', // 封面地址
      notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
      controlBar: {
        timeDivider: false, // 当前时间和持续时间的分隔符
        durationDisplay: false, // 显示持续时间
        remainingTimeDisplay: false, // 是否显示剩余时间功能
        fullscreenToggle: true // 是否显示全屏按钮
      }
    }
    setTimeout(() => {
      this.loadDH = true
    }, 500)
  },
  updated() {},

  destroyed() {},

  methods: {
    onPlayerEnded() {
      if (this.playerOptions.poster == '') {
        this.playerOptions.poster = this.apiserver + '/upload/video/fengmian.jpeg'
      }
      this.playerOptions.autoplay = false
    }
  }
}
</script>

<style scoped lang="scss">
.el-header {
  height: auto !important;
}

.el-main {
  min-height: auto !important;
  margin-bottom: 50px;
}
.nesc_jianjie {
  width: 100%;
  .banner_h {
    height: calc(100% + 70px);
    position:relative;
    video {
      height: 100%;
    }
  }
}

.nesc_about_content {
  position: relative;
  z-index: 1;
  overflow: visible !important;
  margin: 0 auto;
}

/* 企业简介 */
.nesc_d2s1_txt {
  margin: 0 auto;
  width: 75%;
  @media screen and (max-width: 991px) {
    padding-left: 0;
  }
  @media screen and (max-width: 767px) {
    width: 100%;
  }
  p {
    color: #333;
    line-height: 1.5;
    padding-left: 0;
    font-size: 18px;
    letter-spacing: 1px;
    @media screen and (max-width: 991px) {
      line-height: 30px;
    }
    @media screen and (max-width: 767px) {
      line-height: 24px;
    }
  }
}
</style>

<style lang="scss">
.vjs-custom-skin {
  width: 100%;
  height: 100%;
  .video-js>.vjs-big-play-button {
    left: 50%;
    top: 50%;
    transform:translate(-50%,-50%);
  }
}
</style>

<style scoped lang="scss">
/* about-history */
.nesc_history {
  background: url('../../assets/image/bg_about_history.jpeg') center / cover no-repeat;
  width: 100%;
  margin-bottom: 10px;
  @media screen and (min-width: 769px){
    margin-bottom: 50px
  }
  .nesc_about_content {
    .about-title {
      h3 {
        margin: 0 0 10px;
        font-size: 30px;
        font-weight: 400;
        color: #d6d6d6;
        @media screen and (max-width: 767px) {
          font-size: 24px;
        }
      }
      p {
        margin: 0;
        font-size: 32px;
        font-weight: 300;
        color: rgba(222, 222, 222, .09);
      }
    }

    .about-history-list {
      position: relative;
      margin-bottom: 40px;
      @media screen and (max-width: 768px){
        margin-top: 20px;
        &.pc {display: none}
        &.phone {display: block}
      }
      @media screen and (min-width: 769px){
        margin-top: -40px;
        &.pc {display: block}
        &.phone {display: none}
      }
      .flex-viewport {
        padding: 0 31px;
        &:before {
          position: absolute;
          top: 50%;
          right: 0;
          left: 0;
          border-top: 1px solid #C7C7C7;
          content: '';
        }
      }

      &.phone {
        ::v-deep .el-timeline-item__timestamp {
          color: #EA6828;
          font-size: 28px;
          background-image: -webkit-linear-gradient(45deg, #fca85f, #ff7900);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        ::v-deep .el-card {
          background: none;
          border: none;
          color: #ffffff;
          font-size: 18px;
        }
        ::v-deep .el-timeline-item__node {
          background-color: #ff975e;
          -webkit-animation: scale 1.5s infinite;
          animation: kuosan 1.5s linear 0.5s infinite;
        }
      }
    }
  }
}

.history-swiper {
  .swiper-button-prev {
    color: rgb(235, 235, 235) !important;
  }
  .swiper-button-next {
    color: rgb(235, 235, 235) !important;
  }
  .swiper-slide {
    position: relative;
    width: 253px;
    height: 420px;
    margin-right: 31px;
    .item {
      position: absolute;
      right: -32px;
      bottom: 0;
      left: -32px;
      min-height: 152px;
      -webkit-transition: all .2s ease;
      -moz-transition: all .2s ease;
      -ms-transition: all .2s ease;
      -o-transition: all .2s ease;
      transition: all .2s ease;
      &:before {
        position: absolute;
        top: -68px;
        left: 50%;
        width: 20px;
        height: 20px;
        overflow: hidden;
        margin-left: -10px;
        -webkit-border-radius: 100%;
        -moz-border-radius: 100%;
        border-radius: 100%;
        content: '';
      }
      &:after {
        position: absolute;
        top: -64px;
        left: 50%;
        width: 12px;
        height: 12px;
        overflow: hidden;
        margin-left: -6px;
        -webkit-border-radius: 100%;
        -moz-border-radius: 100%;
        border-radius: 100%;
        background-color: #ff975e;
        content: '';
        -webkit-animation: scale 1.5s infinite;
        animation: kuosan 1.5s linear 0.5s infinite;
      }
      h3 {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        height: 44px;
        line-height: 44px;
        margin: 0;
        font-size: 40px;
        font-weight: 400;
        color: #EA6828;
        background-image: -webkit-linear-gradient(45deg, #fca85f, #ff7900);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        text-align: center;
        -webkit-transition: all .2s ease;
        -moz-transition: all .2s ease;
        -ms-transition: all .2s ease;
        -o-transition: all .2s ease;
        transition: all .2s ease;
        @media screen and (max-width: 1024px) {
          font-size: 30px;
        }
        &:before {
          position: absolute;
          bottom: 100%;
          left: 50%;
          margin-left: -9px;
          border-width: 0 9px 18px;
          border-style: solid;
          border-color: transparent transparent #E2E2E2;
          content: '';
        }
      }
      .desc {
        line-height: 24px;
        padding: 12px 26px 6px;
        font-size: 16px;
        color: #ffffff;
        letter-spacing: 1px;
        p {
          margin: 0;
        }
      }
    }

    &:nth-child(even) {
      .item {
        top: 0;
        bottom: auto;
        padding: 0 0 44px;
        &:before {
          top: auto;
          bottom: -68px;
        }
        &:after {
          top: auto;
          bottom: -64px;
        }
        h3 {
          top: auto;
          bottom: 0;
          &:before {
            top: 100%;
            bottom: auto;
            border-width: 18px 9px 0;
            border-color: #E2E2E2 transparent transparent;
            margin-top: 10px
          }
        }
      }
    }

    &:nth-child(odd) {
      .item h3:before {
        margin-bottom: 10px;
      }
    }

  }
}

@keyframes kuosan {
  0% {
    box-shadow: 0px 0px 0px 5px rgba(255, 151, 94, .3);
  }
  25% {
    box-shadow: 0px 0px 0px 4px rgba(255, 151, 94, 0.3);
  }
  50% {
    box-shadow: 0px 0px 0px 3px rgba(255, 151, 94, .5);
  }
  75% {
    box-shadow: 0px 0px 0px 4px rgba(255, 151, 94, .3);
  }
  100% {
    box-shadow: 0px 0px 0px 5px rgba(255, 151, 94, .3);
  }
}

@-webkit-keyframes kuosan {
  0% {
    box-shadow: 0px 0px 0px 5px rgba(255, 151, 94, .3);
  }
  25% {
    box-shadow: 0px 0px 0px 4px rgba(255, 151, 94, 0.3);
  }
  50% {
    box-shadow: 0px 0px 0px 3px rgba(255, 151, 94, .5);
  }
  75% {
    box-shadow: 0px 0px 0px 4px rgba(255, 151, 94, .3);
  }
  100% {
    box-shadow: 0px 0px 0px 5px rgba(255, 151, 94, .3);
  }
}

</style>
